module.exports = __webpack_public_path__ + "static/publications.20f5f89b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/covers/publications.jpg
// module id = 160
// module chunks = 96068746775097 261153568727339